import axios from "axios";
import { PDA_PREFIX } from "../../global/constants";

// Window event fired whenever something may have moved a contractual
// milestone's penalty loss (rate/cap edit, contractual-date edit, Gantt date
// PATCH, regeneration). The GW page listens and refetches the loss.
export const PENALTIES_CHANGED_EVENT = "offolio:penalties-changed";

export const emitPenaltiesChanged = () => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(PENALTIES_CHANGED_EVENT));
};

export const fetchPenaltyLoss = async (scenarioId) => {
  const res = await axios.get(
    `${PDA_PREFIX}/constraint-factor/penalty-loss/${scenarioId}`
  );
  return Array.isArray(res?.data) ? res.data : [];
};
